/* istanbul ignore file */
/* react-leaflet incompatible with testing library, tested in cypress! */

import * as React from "react";
import { Circle, LayerGroup, Map, Tooltip } from "react-leaflet";
import classNames from "classnames";

import { DeviceClusterResponse } from "../../../services/core/maps";
import { useClusterProps } from "./utils";
import { useSingleClick } from "@lib/useSingleClick";
import { ClusterContext } from "../../../containers/core/maps/clusterContext";

export interface IClusterProps {
  lat: number,
  lng: number,
  count: number,
  radius: number,
  bounds: string[],
  loading: boolean,
  dataId: string
}


export const Cluster = (props: IClusterProps) => {
  const { lat, lng, count, radius, loading, bounds, dataId } = props;
  const { state, dispatch } = React.useContext(ClusterContext);
  const { handleSingleClick } = useSingleClick();

  const selected = state?.selectedCluster?.join() === bounds.join();

  const onClick = handleSingleClick(() => {
    dispatch({ type: 'SET_SELECTED_CLUSTER', payload: !selected ? bounds : null });
  });

  return <Circle
    data-selected={selected}
    center={{ lat, lng }}
    radius={radius}
    className={classNames("cluster", dataId, { loading, selected })}
    onclick={onClick}
    data-num={count}
  >
    <Tooltip
      permanent={true}
      offset={[0, 0]}
      direction="bottom"
      className={classNames("cluster-label", { loading, selected })}
    >
      {count}
    </Tooltip>
  </Circle>;
};

interface OverlayLayerProps {
  mapRef: React.MutableRefObject<Map>,
  isLoading: boolean,
  data?: DeviceClusterResponse
}

export const OverlayLayer = ({ data, mapRef, isLoading }: OverlayLayerProps) => {
  const bounds = mapRef.current?.leafletElement?.getBounds();

  const clusterProps = useClusterProps(bounds, data);
  const { state } = React.useContext(ClusterContext);
  const selectedCluster = state?.selectedCluster;


  return <LayerGroup>
    {clusterProps.map((clusterProps) => {
      const boundsString = clusterProps.bounds.join();
      const selected = selectedCluster?.join() === boundsString;

      const key = `${boundsString}_${selected}_${clusterProps.count}`;
      const dataId = `cluster_${data.precision}_${clusterProps.count}`;

      return <Cluster {...clusterProps} key={key} dataId={dataId} loading={isLoading} />;
    })}
  </LayerGroup>;
};
